import { FETCH_THEME } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case FETCH_THEME:
      return action.payload
    default:
      return state;
  }
}